import React from 'react'
import numeral from 'numeral'
import Link from '../Link'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'

// import SidebarFooter from '../Sidebar/Footer'

export default ({ lots = [], fixedpricelots = [], totalSum = [], onLinkClick, onLogOut, linkPrefix='lots' }) => {
  return (
<div>
  <div>
      {(totalSum && totalSum.length)
        ? (
          <h1 className='Sidebar__head Sidebar__head_top'>
            <FormattedMessage id='profile_sidebar.you_donated' />
            <br />
            {totalSum.map((el, i) => (
              <span key={i}>
                <nobr>{el.value ? numeral(el.value).format('0,0') : 0} {el.currency}</nobr>
                {(totalSum.length !== (i + 1)) ? ', ' : ''}
              </span>
            ))}
          </h1>
        )
        : <h1 className='Sidebar__head Sidebar__head_top'>
          <FormattedHTMLMessage id='profile_sidebar.you_did_not_donate' />
        </h1>
      }
    <div className='Sidebar__list-body user-profile'>
      {(lots.length > 0)
        ? (
          <div>
		    <span className='Sidebar__list-head'>
			  <FormattedMessage id='profile_sidebar.unpaid_lots' />
		    </span>
            <div className='Sidebar__list'>
              {lots.map(lot => (
                <div className='Sidebar__list-item' key={lot._id}>
                  <span className='Sidebar__list-col Sidebar__list-col_name'><Link to={`/${linkPrefix}/${lot.alias}`}>{lot.title}</Link></span>
                  {/* @new Если не нажимал оплатить и не вводил почту то так если ввел почту то убираем сумму */}
                  <span className='Sidebar__list-col Sidebar__list-col_total'>{lot.sum}</span>
                  {/* @new Если не нажимал оплатить и не вводил почту то так */}
                  <a href={lot.paymentUrl} className='Sidebar__list-col Sidebar__list-col_button Link Link_light'>
                    <FormattedMessage id='profile_sidebar.pay' />
                  </a>
                  {/* @new Если нажимал оплатить и ввел почту то так */}
                  {/* @new <a href={lot.paymentUrl} className='Sidebar__list-col Sidebar__list-col_button Link Link_light'>Ожидает оплаты</a> */}
                </div>
              ))}
            </div>
          </div>
        )
        : (totalSum && totalSum.length)
          ? null
          : <p className='Sidebar__empty Small'>
            <FormattedMessage id='profile_sidebar.not_won' />
          </p>
      }
	  {(fixedpricelots.length > 0)
          ? (
          <div>
			<span className='Sidebar__list-head'>
              <FormattedMessage id='profile_sidebar.paid_fixedpricelots' />
            </span>
			<div className='PayedFixedPriceList'>
              {fixedpricelots.map(lot => (
                <div className='Sidebar__list-item' key={lot._id}>
                  <span className='Sidebar__list-col Sidebar__list-col_name'>{lot.title}</span>
                  <span className='Sidebar__list-col Sidebar__list-col_total'>{lot.price} {lot.currency.symbol}</span>
				  <span className='Sidebar__list-col Sidebar__list-col_button'>
                    {lot.userCountPay}
                  </span>
                </div>
              ))}
            </div>
          </div>
          )
          : (totalSum && totalSum.length)
            ? null
            : <p className='Sidebar__empty Small'>
              <FormattedMessage id='profile_sidebar.not_won' />
            </p>
        }
	</div>
	
  </div>
</div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Profile/Sidebar.jsx